
import InputWithOptions from './inputwithoptions'

export default InputWithOptions;